<template>
  <div class="p-b-5">
    <v-table
      :data="references"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            :custom-sort="typeSort"
            default-sort="asc"
            v-t="'LABEL_TYPE'"
          />
          <v-th
            sort-key="name"
            v-t="'LABEL_NAME'"
          />
          <th v-t="'LABEL_ID'" />
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ row.type }}</td>
          <td>
            <a
              rel="noopener"
              target="_blank"
              :href="row.link"
              class="table-ellipsis__name linked-name"
            >
              <span :title="row.name">
                {{ row.name }}
              </span>
            </a>
          </td>
          <td>
            {{ row.id }}
          </td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
        />
      </div>
    </div>
    
    <div
      v-if="getPredictiveRoutingConfigReferencesStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'ERPC_REFERENCES_LOADING'" />
    </div>
    <div
      v-if="getPredictiveRoutingConfigReferencesStatus.status === 'success' && references.length === 0"
      v-t="'ERPC_REFERENCES_EMPTY'"
      class="well well-sm text-center"
    />
  </div>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loader from '@/core/components/Loader';

export default {
  name: 'PredictiveRoutingConfigReferences',
  components: {
    Loader
  },
  props: {
    configId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapState('predictiveRouting', ['references']),
    ...mapGetters('predictiveRouting', ['getPredictiveRoutingConfigReferencesStatus']),
  },
  created() {
    this.getPredictiveRoutingConfigReferences(this.configId);
  },
  methods: {
    ...mapActions('predictiveRouting', ['getPredictiveRoutingConfigReferences']),
    typeSort(a, b) {
      if (a.type === b.type) {
        if (a.name === b.name) {
          return 0;
        }
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      }
      if (a.type > b.type) {
        return 1;
      }
      return -1;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>